module.exports = __webpack_public_path__ + "img/ios_code.47ff9b71.png";